'use client';
/** @jsxImportSource @emotion/react */

import type { TimelineItemProps } from '@mui/lab/TimelineItem';

import MuiTimelineItem from '@mui/lab/TimelineItem';

export type { TimelineItemProps };

export const TimelineItem: React.FC<TimelineItemProps> = MuiTimelineItem;

TimelineItem.displayName = 'TimelineItem';
